import { useEffect, useMemo, useState } from "react";
import { fetchTevoListingPrice } from "../../Home/MarketplaceNewUI/marketplaceHotEventPrices";
import {
  isTevoNumericEventId,
  resolveListingPrice,
} from "../../Home/MarketplaceNewUI/marketplaceHomeFeaturedFromApi";
import { getTicketsEventPriceKey } from "./ticketsPageHelpers";

/** Load TEVO ticket-page listing prices for events missing inline price data. */
export function useTicketsListingPrices(events, enabled = true) {
  const [listingPrices, setListingPrices] = useState({});
  const [fetching, setFetching] = useState(false);

  const eventsNeedingFetch = useMemo(() => {
    if (!enabled) return [];
    const byId = new Map();
    (events || []).forEach((event) => {
      if (event?._isUserCreated) return;
      const id = event?.id;
      if (!isTevoNumericEventId(id)) return;
      if (resolveListingPrice(event) > 0) return;
      byId.set(String(id), event);
    });
    return [...byId.values()];
  }, [events, enabled]);

  useEffect(() => {
    if (!eventsNeedingFetch.length) {
      setFetching(false);
      return undefined;
    }

    let cancelled = false;
    setFetching(true);

    const loadPrices = async () => {
      const updates = {};
      await Promise.all(
        eventsNeedingFetch.map(async (event) => {
          const key = getTicketsEventPriceKey(event);
          if (!key) return;
          const price = await fetchTevoListingPrice(event.id);
          if (price > 0) updates[key] = price;
        })
      );
      if (!cancelled) {
        if (Object.keys(updates).length > 0) {
          setListingPrices((prev) => ({ ...prev, ...updates }));
        }
        setFetching(false);
      }
    };

    loadPrices();
    return () => {
      cancelled = true;
    };
  }, [eventsNeedingFetch]);

  return { listingPrices, fetching };
}
